export const tabLists = ["B2C", "B2B"];

export const rates = [
  {
    room: "DELUXE DOUBLE BED",
    rates: [
      {
        date: "2025-01-18",
        available: 8,
        sold: 0,
        ratePlan: [
          {
            name: "CP",
            adult_rates: [
              {
                adults: 2,
                rate: 4808.84,
              },
              {
                adults: 3,
                rate: 5500.0,
              },
            ],
          },
        ],
      },
      {
        date: "2025-01-19",
        available: 8,
        sold: 0,
        ratePlan: [
          {
            name: "CP",
            adult_rates: [
              {
                adults: 2,
                rate: 4808.84,
              },
              {
                adults: 3,
                rate: 5500.0,
              },
            ],
          },
        ],
      },
      {
        date: "2025-01-20",
        available: 8,
        sold: 0,
        ratePlan: [
          {
            name: "CP",
            adult_rates: [
              {
                adults: 2,
                rate: 4808.84,
              },
              {
                adults: 3,
                rate: 5500.0,
              },
            ],
          },
        ],
      },
      {
        date: "2025-01-21",
        available: 8,
        sold: 0,
        ratePlan: [
          {
            name: "CP",
            adult_rates: [
              {
                adults: 2,
                rate: 4808.84,
              },
              {
                adults: 3,
                rate: 5500.0,
              },
            ],
          },
        ],
      },
      {
        date: "2025-01-22",
        available: 8,
        sold: 0,
        ratePlan: [
          {
            name: "CP",
            adult_rates: [
              {
                adults: 2,
                rate: 4808.84,
              },
              {
                adults: 3,
                rate: 5500.0,
              },
            ],
          },
        ],
      },
      {
        date: "2025-01-23",
        available: 8,
        sold: 0,
        ratePlan: [
          {
            name: "CP",
            adult_rates: [
              {
                adults: 2,
                rate: 4808.84,
              },
              {
                adults: 3,
                rate: 5500.0,
              },
            ],
          },
        ],
      },
    ],
  },
];

export const generateRows = (number) => {
  if (typeof number !== "number" || number <= 0) {
    return [];
  }

  return Array.from({ length: number }, (_, index) => ({
    adult: number - index,
    amount: "",
  }));
};

export const formatDate = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = (d.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-indexed
  const day = d.getDate().toString().padStart(2, "0");
  return `${year}/${month}/${day}`;
};

export const getDateRange = ({ startDate, endDate }) => {
  const dates = [];
  let currentDate = new Date(startDate);
  const end = new Date(endDate);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-indexed
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  while (currentDate <= end) {
    dates.push(formatDate(new Date(currentDate))); // Format the date as yyyy-mm-dd
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
};

// MUI Data Grid column format
export const hotelColumn = [
  { 
    field: "name", 
    headerName: "Hotel Name", 
    minWidth: 200,
    flex: 1.5,
    sortable: true,
    filterable: false 
  },
  { 
    field: "address", 
    headerName: "Address", 
    minWidth: 250,
    flex: 2,
    sortable: true,
    filterable: false 
  },
  {
    field: "country",
    headerName: "Country",
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return <div>{params.row?.country?.name}</div>;
    },
  },
  {
    field: "state",
    headerName: "State",
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return <div>{params.row?.state?.name}</div>;
    },
  },
  {
    field: "city",
    headerName: "City",
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return <div>{params.row?.city?.name}</div>;
    },
  },
  { 
    field: "typeOfHotel", 
    headerName: "Hotel Type", 
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false 
  },
  {
    field: "starRating",
    headerName: "Star",
    minWidth: 80,
    flex: 0.5,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return <div>{params.row?.additionalHotelDetails?.starRating}</div>;
    },
  },
];

